// GeneratedGifPanel.tsx
import React from 'react';
import { ArrowLeft, Download, Loader2 } from 'lucide-react';
import SaveImageModal from '../modals/SaveImageModal';
import { Button } from 'components/ui/button';
import toast from 'react-hot-toast';
import LoadingGif from '../Loader/LoadingGif';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface GeneratedGifPanelProps {
  gifUrl: string;
  handleSave?: (title: string, video_url: string) => Promise<void>;
  isLoading?: boolean;
  isGenerating?: boolean;
  handleSetPannel: (e: number) => void;
}

const GeneratedGifPanel = ({
  gifUrl,
  handleSave,
  isLoading = false,
  isGenerating = false,
  handleSetPannel,
}: GeneratedGifPanelProps) => {
  const handleDownload = async () => {
    try {
      const response = await fetch(gifUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'generated-gif.mp4';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      toast.success('Download Complete');
    } catch (error) {
      console.error('Download failed:', error);
      toast.error('Failed to download GIF');
    }
  };

  return (
    <div className="w-full bg-background rounded-lg p-4 lg:p-6 mt-4 lg:mt-8">
      {isGenerating ? (
        <div className="flex flex-col items-center justify-center h-48 lg:h-64 space-y-3 lg:space-y-4">
          <Loader2 className="w-8 h-8 lg:w-12 lg:h-12 animate-spin text-primary" />
          <p className="text-base lg:text-lg font-medium text-text-primary text-center">
            Generating your GIF...
          </p>
          <p className="text-xs lg:text-sm text-text-primary text-center">
            This may take a few moments
          </p>
        </div>
      ) : gifUrl ? (
        <div className="flex flex-col">
          <div className="mb-2 lg:mb-3" onClick={() => handleSetPannel(1)}>
            <ArrowLeft
              size={16}
              className="lg:w-[18px] lg:h-[18px] text-primary"
            />
          </div>
          <div className="w-full bg-background rounded-lg p-2 lg:p-4 mb-3 lg:mb-4">
            <video
              className="w-full max-w-4xl mx-auto rounded-lg shadow-lg aspect-video"
              autoPlay
              muted
              loop
              poster="thumbnail.jpg"
            >
              <source src={gifUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          <div className="flex  items-center justify-center flex-col lg:flex-row gap-3 lg:gap-4  ">
            <div className="w-full lg:w-auto">
              <SaveImageModal
                resultsImageUrl={gifUrl}
                handleSave={handleSave}
                isLoading={isLoading}
              />
            </div>

            <div className="w-full lg:w-[300px]">
              <Button
                variant="customPrimary"
                className="w-full"
                onClick={handleDownload}
                disabled={isLoading}
              >
                <Download className="w-5 h-5 mr-2" />
                Download (.mp4)
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <LoadingGif />
      )}
    </div>
  );
};

export default GeneratedGifPanel;
